import { createLucideIcon } from 'lucide-react';

/**
 * Custom Gravestone Icon
 * A tombstone/gravestone icon for Estate Administration matters
 */
export const Gravestone = createLucideIcon('Gravestone', [
  // Tombstone shape - rounded top rectangle
  [
    'path',
    {
      d: 'M6 21h12',
      key: 'base'
    }
  ],
  [
    'path',
    {
      d: 'M7 21V9a5 5 0 0 1 10 0v12',
      key: 'body'
    }
  ],
  [
    'line',
    {
      x1: '10',
      y1: '12',
      x2: '14',
      y2: '12',
      key: 'cross-horizontal'
    }
  ],
  [
    'line',
    {
      x1: '12',
      y1: '10',
      x2: '12',
      y2: '14',
      key: 'cross-vertical'
    }
  ]
]);
